// Delegated controls survive Shopify's variant and theme-editor gallery updates.
if (!window.dhsProductGalleryControlsReady) {
  window.dhsProductGalleryControlsReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dhs-gallery-prev], [data-dhs-gallery-next]');
    if (!button) return;

    const gallery = button.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    const items = [...gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]')];
    if (items.length < 2) return;

    const current = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    const direction = button.hasAttribute('data-dhs-gallery-next') ? 1 : -1;
    const next = items[(current + direction + items.length) % items.length];
    gallery.setActiveMedia(next.dataset.mediaId, false);
  });
}
